import React, {useMemo} from "react";
import {Button, Icon} from "../components/controls";
import {text} from "../utils/i18n";
import {usePaymentViewMutator, usePaymentViewState} from "./payment-view";
import {usePaymentsMutator, usePaymentsState} from "../contexts/payments";
import {client} from "braintree-web";
import {Checkbox} from "../components/fields";
import {post} from "../utils/rmi";
import {useCustomerState} from "../contexts/customer";
import {ErrorModal} from '../components/modals';
import {useModalsMutator, useSiteState} from "../contexts/page";
import {initiateApplePay, initiateGooglePay, initiatePayPal} from "../utils/payments";
import {useMarketState} from "../contexts/market";


const iconHeaderStyling = {
    marginTop: '15px'
};
const cancelStyling = {
    fontWeight:'400',
    lineHeight:'0.95'
};

export const AddDigitalWalletPanel = (props) => {
    const { digitalWalletEnv, googlePayMerchantId, modelName, method, setSubscriptionPayment, subscriptionCode } = props;
    const { viewOptions, mode } = usePaymentViewState();
    const { showPaymentSelect, showPaymentList }= usePaymentViewMutator();
    const { addPayment, hideModal, handleNonceFromFollowAnalytics } = usePaymentsMutator();
    const { customerId } = useCustomerState();
    const { methods, context, cartMarketType, isSubscriptionsPage } = usePaymentsState();
    const { showGlobalModal, hideGlobalModal } = useModalsMutator();
    const { site } = useSiteState();
    const {formats:{currency:{currencyCode}}} = useMarketState();

    React.useEffect(()=> {
        window.addEventListener('paymentDataReceived', handleNonceFromFollowAnalytics);
        return () => window.removeEventListener('paymentDataReceived', handleNonceFromFollowAnalytics);
    }, [handleNonceFromFollowAnalytics]);


    const handleAlternatePaymentError = (clientErr,text) => {
        const modalName = 'add-digital-payment-error';
        showGlobalModal(modalName,
            <ErrorModal text={text} close={() => hideGlobalModal(modalName)}/>);
        showPaymentSelect();
        console.error('Error creating client:', clientErr);
    };
    const determineMarket = (site,cartMarketType) => {
        if (cartMarketType) {
            return cartMarketType;
        }
            return site ? `${site}OTG` : 'USOTG';
        
    };

    const salesOrg = determineMarket(site,cartMarketType);

    const payload = {
        customerId,
        salesOrg,
        transactionType:"CIT"
    };
    useMemo(() => {
        requestAnimationFrame(() => {
            post(`/getDHyCSDigitalWalletToken`, JSON.stringify(payload)).then(tokenResultData =>{

                let event = new CustomEvent("clientToken", {bubbles: true, detail:tokenResultData.clientToken});
                document.body.dispatchEvent(event);

                client.create({
                    authorization: tokenResultData.clientToken
                }, (clientErr, clientInstance) => {

                    // Stop if there was a problem creating the client.
                    // This could happen if there is a network error or if the authorization
                    // is invalid.
                    if (clientErr) {
                        handleAlternatePaymentError(clientErr, text("text.payment.altPayment.error"));
                        return;
                    }

                    const altPaymentParameters = {
                        clientInstance,
                        addPayment,
                        showPaymentList,
                        handleAlternatePaymentError,
                        modelName,
                        hideModal,
                        digitalWalletEnv,
                        googlePayMerchantId,
                        currencyCode
                    };

                    switch(method ? method : mode) {
                        case "apple-pay":
                            initiateApplePay(altPaymentParameters, mode, setSubscriptionPayment, subscriptionCode);
                            break;
                        case "paypal":
                            initiatePayPal(altPaymentParameters, mode, setSubscriptionPayment, subscriptionCode);
                            break;
                        case "google-pay":
                            initiateGooglePay(altPaymentParameters, mode, setSubscriptionPayment, subscriptionCode);
                            break;
                        default:

                    }

                });
            }, (err)=> {
                handleAlternatePaymentError(err, text("text.payment.altPayment.error"));
            });
        });
    },[customerId]);

    return (
        <div className="row">
            <div className={`col-xs-12${viewOptions.fullWidth ? '' : ' col-md-6'}`}>
                <div className='manage-credit-card panel panel-product panel-default'>
                    <div className='list-group-item'>
                        <div className='payment-header'>
                            <div className='payment-title'>
                                <Icon name='payment-generic' size='medium' cssStyles={iconHeaderStyling}/>
                                <h5>
                                    {text("text.payment.altPayment.title")}
                                </h5>
                            </div>
                            <div className='payment-back'>
                                {(context !== 'enrollment' || methods.length > 1) &&
                                    <Button id={"hidePayment"} disabled={false} text={text("text.button.label.back")}
                                            classes={"btn btn-link"} onClick={showPaymentSelect}
                                            cssStyles={cancelStyling} ariaLabel={text("text.button.label.back.payment.method")}/>
                                }
                            </div>
                        </div>
                        <div style={{marginTop: '10px'}}>
                            {text("text.payment.method.intro." + mode)}
                        </div>
                        {viewOptions.makeDefault && !isSubscriptionsPage &&
                            <Checkbox id="makeDefault" name="makeDefault" labelKey={"form.paymentManagement.makeDefault"} classes="form-control" labelClasses="shipping-label" defaultChecked={false}/>
                        }
                        <div id={mode}>
                            <div id="dwLoading" className="spinner spinner--brand" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


